/// <amd-module name="TFS/Admin/Common/Providers/PersonaDetailsProvider" />

import * as React from "react";

import {
    IIdentity,
    IdentitiesGetConnectionsResponseModel as IPersonaConnections,
    IVssIdentityService,
    VssIdentityServiceName
} from "VSS/Features/Identities/IdentityService";
import { IIdentityDetailsProvider, IPersonaProvider } from "VSSUI/Persona";
import { IPageData, IVssPageService } from "VSS/Platform/Page";

import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityCard } from "VSSUI/IdentityCard";

export class PersonaDetailsProvider implements IPersonaProvider {
    private identityService: IVssIdentityService;
    private pageData: IPageData;

    public constructor(pageContext: IVssPageContext) {
        this.identityService = pageContext.getService<IVssIdentityService>(VssIdentityServiceName);
        this.pageData = pageContext.getService<IVssPageService>("IVssPageService").getData()!;
    }

    public onRequestConnectionInformation = (
        entity: IIdentity,
        getDirectReports?: boolean | undefined
    ): IPersonaConnections | PromiseLike<IPersonaConnections> => {
        if (!entity) {
            return {} as IPersonaConnections;
        }

        return this.identityService.getConnections(entity, getDirectReports);
    };

    public getEntityFromUniqueAttribute = (entityId: string): IIdentity | PromiseLike<IIdentity> => {
        return this.identityService
            .searchIdentitiesAsync(entityId, ["user", "group"], this.pageData.isHosted ? ["ims", "source"] : ["ims", "source", "ad"], "uid")
            .then((x) => x[0]);
    };

    public renderIdentityCard = (
        identity: IIdentity,
        detailsProvider: IIdentityDetailsProvider,
        onDismiss: () => void,
        target: HTMLElement
    ): JSX.Element => {
        const uniqueAttribute = identity.entityId ? identity.entityId : identity.subjectDescriptor;
        return (
            <IdentityCard
                target={target}
                onDismissCallback={onDismiss}
                uniqueAttribute={uniqueAttribute}
                displayName={identity.displayName}
                onRequestConnectionInformation={detailsProvider.onRequestConnectionInformation}
                getEntityFromUniqueAttribute={detailsProvider.getEntityFromUniqueAttribute}
            />
        );
    };
}
